/**
 * API Configuration Utility
 * 
 * Provides a centralized API URL configuration with automatic fallback
 * for production environments where REACT_APP_BACKEND_URL may not be set.
 */

// API URL configuration with fallback for production
const getApiUrl = () => {
  // Check for environment variable first
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  // In production, use the same origin (backend served from same domain)
  if (typeof window !== 'undefined') {
    const currentOrigin = window.location.origin;
    // If we're on a custom domain (not localhost), use same origin
    if (!currentOrigin.includes('localhost') && !currentOrigin.includes('127.0.0.1')) {
      return currentOrigin;
    }
  }
  
  // Fallback for development
  return 'http://localhost:8001';
};

export const API_URL = getApiUrl();

export default API_URL;
